// extracted by mini-css-extract-plugin
module.exports = {"highlightCard":"HighlightCard_highlightCard__3TqG1","data":"HighlightCard_data__3ZGDU","value":"HighlightCard_value__GV7bA","chip":"HighlightCard_chip__1vqY5"};